/**
 * @file
 * A JavaScript file containing the Videos slider
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth



(function ($) {
    Drupal.behaviors.videoslider = {
      attach: function (context) {
        'use strict';
      }
    }

    $(document).ready(function() {
      $('.video-blk .views-content').slick({
        arrows: false,
        mobileFirst: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: "unslick"
          }
        ]
      });

      //Remove Youtube controls and Play Looping

if($('.node--view-mode-card-landscape-video-banner').length != 0){
  var iframe_source = jQuery('.video-embed-field-provider-youtube iframe').attr('src');
  var splitsrc = iframe_source.split('embed/')[1];
  var getplaylist = splitsrc.split('?')[0];
  var controls ='&controls=0&loop=1&showinfo=0&modestbranding=1&mute=1&playlist='+getplaylist;
  var new_source = iframe_source + controls;
  jQuery('.video-embed-field-provider-youtube iframe').attr('src',new_source);
}

    });

  })(jQuery);
